import localesEs from '@/shared/i18n/AuthB2C/es';
import { LOGIN_PAGE_KEY } from '@/views/Login/constants';

const es = {
  [LOGIN_PAGE_KEY]: {
    ...localesEs,
    SEO_TITLE: 'Inicia sesión',
    SEO_DESCRIPTION: 'Inicia sesión y aprende nuevas habilidades hoy.',
    FORM_TITLE: 'Bienvenido de vuelta',
    FORM_DESCRIPTION: 'Qué bueno verte otra vez :)',
    FORM_TITLE_RENOVATION: '¡Una sorpresa te espera!',
    FORM_DESCRIPTION_RENOVATION: 'Ingresa a tu cuenta para verla',
    INPUT_EMAIL_LABEL: 'Correo',
    INPUT_EMAIL_HINT: 'Ingresa tu correo',
    INPUT_PASSWORD_LABEL: 'Contraseña',
    INPUT_PASSWORD_HINT: 'Ingresa tu contraseña',
    FORGOT_PASSWORD: '¿Olvidaste la contraseña?',
    BUTTON_SUBMIT_LABEL: 'Inicia sesión',
    FIRST_TIME_IN_CREHANA: '¿Es la primera vez que usas Crehana?',
    REGISTER: 'Regístrate',
    LOGIN_WITH_YOUR_ORGANIZATION: 'Inicia con tu organización',
    LOGIN_WITH_YOUR_ORGANIZATION_DESKTOP: 'Inicia sesión con tu organización',
  },
};

export default es;
